export default "__VITE_ASSET__BNGU7BQ5__"